import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar';
import $ from 'jquery';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class superadminsidebar extends Component {
  state = {
    rolesList: [],
    Admin: '',
  };
  componentWillMount() {
    // this.props.getRole();
  }

  componentWillReceiveProps(nextProps) {
    // console.log("data",data);/
  }

  constructor(props) {
    super(props);
    this.state = {
      Tab: 'index',
      SubTab: '',
      MoreTab: '',
      dashboard_menu: false,
      chats: false,
    };
  }

  setActiveTab = (tab, subtab, moretab, toggleTab, e) => {
    this.setState({ Tab: tab, SubTab: subtab, MoreTab: moretab });
    console.log('TT', tab, subtab, moretab, toggleTab);
  };

  componentDidMount() {
    var now_route = '';
    var pageUrl = window.location.pathname.split(/[?#]/)[0];
    now_route = pageUrl.substr(1).replace(/_/g, ' ');
    $('#now_routing').empty();
    if (now_route == '') {
      now_route = 'Dashboard';
    } else {
    }
    $('#now_routing').append(now_route);

    $('.toggle-search').on('click', function () {
      var targetId = $(this).data('target');
      var $searchBar;
      if (targetId) {
        $searchBar = $(targetId);
        $searchBar.toggleClass('open');
      }
    });

    $('.button-menu-mobile').on('click', function (event) {
      event.preventDefault();
      $('body').toggleClass('enlarged');
    });

    $('li.has_sub li').on('click', function (event) {
      $('body').toggleClass('enlarged');
    });
  }
  componentDidUpdate() {
    var now_route = '';
    var pageUrl = window.location.pathname.split(/[?#]/)[0];
    now_route = pageUrl.substr(1).replace('_', ' ');
    $('#now_routing').empty();
    if (now_route == '') {
      now_route = 'Dashboard';
    } else {
    }
    $('#now_routing').append(now_route);
  }

  render() {
    // const { roleList } = this.props;

    return (
      <div className="left side-menu">
        <div className="topbar-left">
          <div className="">
            <Link to="/" className="logo">
              <img src="/assets/images/logo.webp" height="45" alt="logo" />
            </Link>
          </div>
        </div>

        <div className="sidebar-inner slimscrollleft">
          <PerfectScrollbar>
            <div id="sidebar-menu">
              <ul>
                <li>
                  <Link
                    className={
                      this.state.SubTab === 'dashboard' ? 'active-menu' : ''
                    }
                    onClick={this.setActiveTab.bind(
                      this,
                      'index',
                      'dashboard',
                      ''
                    )}
                    to="/"
                  >
                    <i className="typcn typcn-th-large-outline"></i>Dashboard
                  </Link>
                </li>
                <li>
                  <Link
                    className={
                      this.state.SubTab === 'domain' ? 'active-menu' : ''
                    }
                    onClick={this.setActiveTab.bind(
                      this,
                      'index',
                      'domain',
                      ''
                    )}
                    to="/domains"
                  >
                    <i className="mdi mdi-earth"></i>Domains
                  </Link>
                </li>

                <li>
                  <Link
                    className={
                      this.state.SubTab === 'chats' ? 'active-menu' : ''
                    }
                    onClick={this.setActiveTab.bind(this, 'index', 'chats', '')}
                    to="/chats"
                  >
                    <i className="mdi mdi-message-outline"></i>Chats
                  </Link>
                </li>
              </ul>
            </div>

            <div className="clearfix"></div>
          </PerfectScrollbar>
        </div>
      </div>
    );
  }
}

superadminsidebar.propsTypes = {
  // getRole: PropTypes.func.isRequired
};
var mapStateToProps = (state) => ({
  Webtracker: state.Webtracker,
});

export default withRouter(connect(mapStateToProps, {})(superadminsidebar));
